import { PermissionDataImpl } from "../data/PermissionDataImpl";
import { IPermissionDataRepository } from "../domain/repositories/IPermissionDataRepository";
import { PermissionDataUseCase } from "../domain/useCases/PermissionDataUseCase";
import { PermissionDataViewModel } from "../presentation/viewModel/PermissionDataViewModel";
import { InjectionBinding, InjectionModule } from "app/di/DependencyInjections";

export class PermissionDataInjection extends InjectionModule {
  private static readonly permissionDataRepositoryToken = Symbol(
    "IPermissionDataRepository",
  );
  private static readonly permissionDataUseCaseToken = Symbol(
    "PermissionDataUseCase",
  );
  private static readonly permissionDataViewModelToken = Symbol(
    "PermissionDataViewModel",
  );

  protected static override bindings: InjectionBinding[] = [
    {
      scope: "otherRepo",
      token: this.permissionDataRepositoryToken,
      useClass: PermissionDataImpl,
    },
    {
      scope: "otherRepo",
      token: this.permissionDataUseCaseToken,
      useClass: PermissionDataUseCase,
    },
    {
      scope: "viewModel",
      token: this.permissionDataViewModelToken,
      useClass: PermissionDataViewModel,
    },
  ];

  static getRepo(): IPermissionDataRepository {
    return this.resolve(this.permissionDataRepositoryToken);
  }

  static getUseCase(): PermissionDataUseCase {
    return this.resolve(this.permissionDataUseCaseToken);
  }
}
